/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
import Text, { TEXT_TYPES } from '../text';

// Styles
import { baseStyle } from './style';

export interface TestimonialCardProps {
  quote: string;
  fullName: string;
  position: string;
  image?: ImageType;
}

const TestimonialCard: FunctionComponent<TestimonialCardProps> = React.memo(
  ({ quote, fullName, position, image }: TestimonialCardProps) => (
    <Flex sx={baseStyle.mainContainer}>
      <Box>
        <Flex sx={baseStyle.innerContent}>
          <Text type={TEXT_TYPES.PULL_QUOTE} sx={baseStyle.pullQuote} lines="4">
            <span dangerouslySetInnerHTML={{ __html: quote }} />
          </Text>
          <Box>
            <Text type={TEXT_TYPES.SUBTITLE} sx={baseStyle.fullName} lines="1">
              {fullName}
            </Text>
            <Text type={TEXT_TYPES.SUBTITLE} sx={baseStyle.position} lines="1">
              {position}
            </Text>
            {image && (
              <Flex sx={baseStyle.imageContainer}>
                <FluidImage {...image} sx={baseStyle.image} />
              </Flex>
            )}
          </Box>
        </Flex>
      </Box>
    </Flex>
  ),
);

export default TestimonialCard;
